import produce from "immer";
import { DashboardActions } from ".";
import { LoadState } from "../../constants/enums";
import { FETCH_MECHANIC_COMPLAINTS, FETCH_TRANSACTIONS_LIST_FAILED, FETCH_TRANSACTIONS_LIST_PROGRESS, FETCH_TRANSACTIONS_LIST_SUCCESS, FETCH_USER_TRANSACTIONS_BY_DATE } from "../constants";
import { IStoreState } from "../initialStoreState";
import { initialDashboard } from "./types";
import { FETCH_MECHANIC_LIST_FAILED, FETCH_MECHANIC_LIST_PROGRESS, FETCH_MECHANIC_LIST_SUCCESS, FETCH_MECHANIC_DASHBOARD_ANALYTICS_PROGRESS, FETCH_MECHANIC_DASHBOARD_ANALYTICS_SUCCESS, FETCH_MECHANIC_DASHBOARD_ANALYTICS_FAILED, CLEAR_MECHANIC_ANALYTICS, FETCH_FINANCE_LIST_PROGRESS, FETCH_FINANCE_LIST_SUCCESS, FETCH_FINANCE_LIST_FAILED, FETCH_FINANCE_ANALYTICS_PROGRESS, FETCH_FINANCE_ANALYTICS_SUCCESS, FETCH_FINANCE_ANALYTICS_FAILED, CLEAR_FINANCE_ANALYTICS, FETCH_SALES_LEAD_LIST_SUCCESS, FETCH_SALES_LEAD_LIST_FAILED, FETCH_SALES_LEAD_LIST_PROGRESS, FETCH_SALES_LEAD_ANALYTICS_FAILED, FETCH_SALES_LEAD_ANALYTICS_PROGRESS, FETCH_SALES_LEAD_ANALYTICS_SUCCESS,  } from "./dashboardActions";

export const dashboardReducer = (
  state: IStoreState["dashboard"] = initialDashboard,
  action: DashboardActions
) => {
  switch (action.type) {
    case FETCH_USER_TRANSACTIONS_BY_DATE: {
      const { key, list, count } = action.payload;
      const newState = produce(state, (draftState) => {
        
        draftState.userTransactions.transactionsByDate[key] = {
          count: count,
          list: list,
        };
      });
      return newState;
    }
    case FETCH_MECHANIC_COMPLAINTS: {
      const { key, list, count } = action.payload;
      const newState = produce(state, (draftState) => {
        
        draftState.complaints.compaintsByDate[key] = {
          count: count,
          list: list,
        };
      });
      return newState;
    }
    case FETCH_MECHANIC_LIST_PROGRESS:{
      const newState = produce(state, (draftState) => {
        draftState.mechanicComplaint.loading = LoadState.InProgress;
      });
      return newState;
    }
    case FETCH_MECHANIC_LIST_SUCCESS:{
      const {list, totalRecords, records, amount} = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.mechanicComplaint.list = list;
        draftState.mechanicComplaint.totalRecords = totalRecords;
        draftState.mechanicComplaint.loading = LoadState.Loaded;
        draftState.mechanicComplaint.amount = amount
        draftState.mechanicComplaint.records = records;
       
 
      });
      return newState;
    }
    case FETCH_MECHANIC_LIST_FAILED:{
      const {error}= action.payload;
      const newState = produce(state, (draftState) => {
        draftState.mechanicComplaint.loading = LoadState.Failed;
        draftState.mechanicComplaint.error = error;
      });
      return newState;
    }
    case FETCH_MECHANIC_DASHBOARD_ANALYTICS_PROGRESS:{
      const newState = produce(state, (draftState) => {
        draftState.analytics.loading = LoadState.InProgress;
      });
      return newState;
    }
    case FETCH_MECHANIC_DASHBOARD_ANALYTICS_SUCCESS:{
      const {data} = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.analytics.data = data;
        draftState.analytics.loading = LoadState.Loaded;
      });
      return newState;
    }
    case FETCH_MECHANIC_DASHBOARD_ANALYTICS_FAILED:{
      const {error} = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.analytics.loading = LoadState.Failed;
        draftState.analytics.error = error;
      });
      return newState;
    }
    case CLEAR_MECHANIC_ANALYTICS:{
      const newState = produce(state, (draftState) => {
        draftState.analytics.data = initialDashboard.analytics.data;
        draftState.analytics.loading = LoadState.NotLoaded;
        draftState.analytics.error = null;
      });
      return newState;
    }

    // Finance List Cases
    case FETCH_FINANCE_LIST_PROGRESS:{
      const newState = produce(state, (draftState) => {
        draftState.finance.loading = LoadState.InProgress;
        draftState.finance.totalAmount = 0;
        draftState.finance.totalRecords = 0;
        draftState.finance.list = [];
      });
      return newState;
    }
    case FETCH_FINANCE_LIST_SUCCESS:{
      const {list, totalRecords,totalAmount} = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.finance.list = list;
        draftState.finance.totalRecords = totalRecords;
        draftState.finance.totalAmount = totalAmount;
        draftState.finance.loading = LoadState.Loaded;
      });
      return newState;
    }
    case FETCH_FINANCE_LIST_FAILED:{
      const {error} = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.finance.loading = LoadState.Failed;
        draftState.finance.error = error;
        draftState.finance.totalAmount = 0;
        draftState.finance.totalRecords = 0;
        draftState.finance.list = [];
      });
      return newState;
    }

    // Finance Analytics Cases
    case FETCH_FINANCE_ANALYTICS_PROGRESS:{
      const newState = produce(state, (draftState) => {
        draftState.finance_analytics.loading = LoadState.InProgress;
      });
      return newState;
    }
    case FETCH_FINANCE_ANALYTICS_SUCCESS:{
      const {data} = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.finance_analytics.totalRecords = data;
        draftState.finance_analytics.loading = LoadState.Loaded;
      });
      return newState;
    }
    case FETCH_FINANCE_ANALYTICS_FAILED:{
      const {error} = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.finance_analytics.loading = LoadState.Failed;
        draftState.finance_analytics.error = error;
      });
      return newState;
    }
    case CLEAR_FINANCE_ANALYTICS:{
      const newState = produce(state, (draftState) => {
        draftState.finance_analytics.totalRecords = initialDashboard.finance_analytics.totalRecords;
        draftState.finance_analytics.loading = LoadState.NotLoaded;
        draftState.finance_analytics.error = null;
      });
      return newState;
    }

    // Transactions List Cases
    case FETCH_TRANSACTIONS_LIST_PROGRESS:{
      const newState = produce(state, (draftState) => {
        draftState.transactions.loading = LoadState.InProgress;
        draftState.transactions.totalAmount = 0;
        draftState.transactions.totalRecords = 0;
        draftState.transactions.records = {
          currentRecords: 0,
          totalPages: 0,
          totalRecords: 0
        };
        draftState.transactions.list = [];
      });
      return newState;
    }
    case FETCH_TRANSACTIONS_LIST_SUCCESS:{
      const {list, totalRecords, records, amount} = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.transactions.list = list;
        draftState.transactions.totalRecords = totalRecords;
        draftState.transactions.records = records;
        draftState.transactions.loading = LoadState.Loaded;
        if (amount) {
          draftState.transactions.totalAmount = parseFloat(amount);
        }
      });
      return newState;
    }
    case FETCH_TRANSACTIONS_LIST_FAILED:{
      const {error} = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.transactions.loading = LoadState.Failed;
        draftState.transactions.error = error;
        draftState.transactions.totalAmount = 0;
        draftState.transactions.totalRecords = 0;
        draftState.transactions.records = {
          currentRecords: 0,
          totalPages: 0,
          totalRecords: 0
        };
        draftState.transactions.list = [];
      });
      return newState;
    }
    // Sales Lead List Cases
    case FETCH_SALES_LEAD_LIST_PROGRESS:{
      const newState = produce(state, (draftState) => {
        draftState.salesLead.loading = LoadState.InProgress;
      });
      return newState;
    }
    case FETCH_SALES_LEAD_LIST_SUCCESS:{
      const {list, totalRecords, totalAmount} = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.salesLead.list = list;
        draftState.salesLead.totalRecords = totalRecords;
        draftState.salesLead.totalAmount = totalAmount;
        draftState.salesLead.loading = LoadState.Loaded;
      });
      return newState;
    }
    case FETCH_SALES_LEAD_LIST_FAILED:{
      const {error} = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.salesLead.loading = LoadState.Failed;
        draftState.salesLead.error = error;
      });
      return newState;
    }
    // Sales Lead Analytics Cases
    case FETCH_SALES_LEAD_ANALYTICS_PROGRESS:{
      const newState = produce(state, (draftState) => {
        draftState.salesLead_analytics.loading = LoadState.InProgress;
      });
      return newState;
    }
    case FETCH_SALES_LEAD_ANALYTICS_SUCCESS:{
      const {data} = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.salesLead_analytics.totalRecords = data;
        draftState.salesLead_analytics.loading = LoadState.Loaded;
      });
      return newState;
    }
    case FETCH_SALES_LEAD_ANALYTICS_FAILED:{
      const {error} = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.salesLead_analytics.loading = LoadState.Failed;
        draftState.salesLead_analytics.error = error;
      });
      return newState;
    }

    default:
      return state;
  }
};
